import React from "react";
import CaretIconToggle from "@common/Icons/CaretIconToggle";
import { useAppearanceContext } from "@contexts/AppearanceContext";
import "./LifeAtButton.scss";

export interface LifeAtButtonProps {
    readonly isLink: boolean;
    readonly isDropdown?: boolean;
    readonly isDropdownOpen?: boolean;
    readonly text?: string; // also acts as alt text if button has icon instead of text label
    readonly icon?: React.ReactNode; // <img> image to use, not required
    readonly link?: string | undefined;
    readonly handleClick?: () => any | undefined; // onclick handler, can be undefined
    readonly disabled?: boolean;
    readonly openInCurrTab?: boolean;
    readonly className?: string; // optional, for use with styled-components
    readonly idVal?: string;
}

/**
 * @deprecated Use {@link LifeAtButtonV2.tsx}
 */
export default function LifeAtButton(props: LifeAtButtonProps) {
    const { lightMode } = useAppearanceContext();

    const getClassNames = () => {
        const classNames = [
            "lifeat-button",
            props.isLink ? "link" : "action",
            lightMode ? "light" : "dark",
            props.disabled ? "disabled" : "",
        ];
        if (props.className) {
            classNames.push(props.className);
        }
        return classNames.join(" ");
    };

    const buttonVisualContent: JSX.Element = (
        <span className="lifeat-button-visual">
            {props.icon && <span className="lifeat-button-icon">{props.icon}</span>}
            {props.text && <span className="lifeat-button-text">{props.text}</span>}
            {props.isDropdown && <CaretIconToggle showOpen={props.isDropdownOpen} className="lifeat-button-caret" />}
        </span>
    );

    const buttonComponent: JSX.Element = props.isLink ? (
        <a
            className="lifeat-button-href"
            href={props.link}
            target={props.openInCurrTab ? "_self" : "_blank"}
            rel="noopener"
        >
            {buttonVisualContent}
        </a>
    ) : (
        <button type={"button"} onClick={(e) => e.currentTarget.blur()}>
            {buttonVisualContent}
        </button>
    );

    const handleClick = () => {
        if (props.disabled || !props.handleClick) {
            return;
        } else {
            props.handleClick();
        }
    };

    return (
        <div id={props.idVal} className={getClassNames()} onClick={handleClick} role={props.link ? "link" : "button"}>
            {buttonComponent}
        </div>
    );
}
